/**
 * 编辑菜单的选区像素动作（M3-05 / DESIGN.md §6.1）。
 *
 * 「清除」= Delete/Backspace（选区内变透明，无选区时禁用——没有选区
 * "清除"清的是什么不明确）。「填充前景色」= Alt+Delete，无选区时填满
 * 整个活动图层（真实 Photoshop 行为，见 fillSelectionWithColor）。
 * 两者都以活动 raster 图层为目标（M3-01）。「填充…」对话框（更完整的
 * 填充方式/混合模式/不透明度）在 main.tsx 里注册，不在这个文件——它需要
 * 打开一个 UI 层的对话框，跟这里其余纯 store 操作的动作不是一类。
 * Delete 不在 §7.4 的动作快捷键表里（那张表只收带修饰键的组合），
 * 所以这里直接写字面量而不动 PHOTOSHOP_ACTION_SHORTCUTS。
 */
import type { ActionRegistry } from './registry';
import type { AppStore } from '../store';
import { clearSelectedPixels } from '../selection-edit';

export interface EditActionDeps {
  readonly store: AppStore;
}

export function registerEditActions(registry: ActionRegistry, deps: EditActionDeps): void {
  registry.register({
    id: 'edit.clear',
    title: '清除',
    group: '编辑',
    section: 2,
    order: 0,
    shortcut: { key: 'Delete' },
    enabled: (s) => s.hasSelection,
    run: () => {
      clearSelectedPixels(deps.store);
    },
  });

  // 「填充前景色」菜单项已移除（真实 Photoshop 现在的编辑菜单里也没有它，
  // 只留「填充…」对话框——Contents 选"前景色"就是同一件事）。Alt+Delete
  // 这个键位作为历史遗留快捷键继续保留，直接在 main.tsx 的键盘处理里接住，
  // 不再走菜单/动作注册表（同 X 交换前景/背景色的处理方式），
  // 免得菜单栏又出现一个重复入口。

  // 独立的"内容识别填充"菜单项已经并入「填充…」对话框（Contents 选"内容
  // 识别"），两处功能重复容易让人以为哪个坏了——只留对话框这一条路径。
}
